






























import Vue from 'vue';
import { mapGetters } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import ProductAPI from '@/services/ProductAPI';
import UserAPI from '@/services/UserAPI';

import Product from '@/types/Product';

export default Vue.extend({
	name: 'ProductCard',

	props: {
		product: Object as () => Product,
		showLiked: { type: Boolean, default: true },
		showCollected: { type: Boolean, default: true },
		allowToogle: { type: Boolean, default: false }
	},

	computed: {
        ...mapGetters(['isCollected', 'isLiked', 'isSignedIn', 'getLanguage'])
	},

	methods: {
		list: (product: Product): string => {
            return Product.listProductionPeriod(product.productionPeriods);
        },

        toggleProductCollected(productId: string) {
			if (!this.allowToogle) {
				return;
			}

			if (!this.isSignedIn) {
				alert(this.$text('signInToAddToCollection'));
				return;
			}

			const handleResponse = (response: AxiosResponse) => {
				this.$store.commit('setUser', response.data.user);
			};

			const handleError = (error: AxiosError) => {
				if (error.response) {
					alert(error.response.data.message);
				}
			};

			if (this.isCollected(productId)) {
				UserAPI
					.deleteCollect(productId)
					.then(handleResponse)
					.catch(handleError);
			} else {
				UserAPI
					.postCollect(productId)
					.then(handleResponse)
					.catch(handleError);
			}

        },

        toggleProductLiked(productId: string) {
			if (!this.allowToogle) {
				return;
			}

			const handleResponse = (response: AxiosResponse) => {
				this.$store.commit('setUser', response.data.user);
				this.loadProducts();
			};

			const handleError = (error: AxiosError) => {
				if (error.response) {
					alert(error.response.data.message);
				}
			};

			if (this.isLiked(productId)) {
				UserAPI
					.deleteLike(productId)
					.then(handleResponse)
					.catch(handleError);
			} else {
				UserAPI
					.postLike(productId)
					.then(handleResponse)
					.catch(handleError);
			}
        },

        loadProducts(): void {
            ProductAPI
                .get()
                .then((axiosResponse: AxiosResponse) => this.$store.commit('setProducts', axiosResponse.data))
                .catch((error: AxiosError) => error);
        }
	}
});
